'use client';

import { c as _c } from "react/compiler-runtime";
import React, { createContext, ReactNode, useContext, useCallback } from 'react';

/**
 * Lightweight provider for discountCodeProvider function
 * Must be positioned ABOVE CoursePriceProvider in the tree
 *
 * This provider computes the discountCodeProvider function that tells
 * the pricing API which discount code to validate.
 *
 * Provider Hierarchy:
 * DiscountCodeProvider (this)
 *   → CoursePriceProvider (receives discountCodeProvider)
 *     → CLPPurchaseContextProvider (uses useCoursePrice)
 */
interface DiscountCodeProviderContextValue {
  discountCodeProvider: () => string | undefined;
}
const DiscountCodeProviderContext = createContext<DiscountCodeProviderContextValue | undefined>(undefined);
export function DiscountCodeProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const discountCodeProvider = _temp;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      discountCodeProvider
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <DiscountCodeProviderContext.Provider value={t1}>{children}</DiscountCodeProviderContext.Provider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}

/**
 * Hook to access the discount code provider function
 * @returns DiscountCodeProviderContextValue
 * @throws Error if used outside of DiscountCodeProvider
 */
function _temp() {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("couponCode") || undefined;
  }
}
export function useDiscountCodeProvider() {
  const context = useContext(DiscountCodeProviderContext);
  if (!context) {
    throw new Error("useDiscountCodeProvider must be used within DiscountCodeProvider");
  }
  return context;
}